import { z } from 'zod'
import { IndividualContactType } from 'generated/graphql'

const individualWithRelationsSchema = z
  .object({
    individual: z
      .object({
        id: z.string(),
        firstName: z.string().nullish(),
        lastName: z.string().nullish(),
        email: z.string().nullish()
      })
      .passthrough(),
    parentRelations: z
      .array(
        z
          .object({
            isPrimaryContact: z.boolean().nullish(),
            isContact: z.boolean().nullish(),
            contactTypes: z.array(z.string()).nullish(),
            signsTaxDocuments: z.boolean().nullish()
          })
          .passthrough()
      )
      .nullish()
  })
  .passthrough()

export const individualsSchema = z.object({
  individuals: z
    .array(individualWithRelationsSchema)
    .refine(
      individuals =>
        individuals.some(ind =>
          ind.parentRelations?.some(rel => rel.isPrimaryContact)
        ),
      { message: 'mainContactRequired', path: ['mainContact'] }
    )
    .refine(
      individuals =>
        individuals.some(ind =>
          ind.parentRelations?.some(
            rel =>
              rel.isContact &&
              rel.contactTypes?.includes(IndividualContactType.Chargeback)
          )
        ),
      { message: 'chargebackContactRequired', path: ['chargebackContact'] }
    )
    .refine(
      individuals =>
        individuals.some(ind =>
          ind.parentRelations?.some(rel => rel.signsTaxDocuments)
        ),
      { message: 'signerRequired', path: ['signer'] }
    )
})

export type IndividualsForm = z.infer<typeof individualsSchema>
